<template>
  <div class="modal-out">
    <div class="modal" style="width: 1000px">
      <div class="modal-header">
        <div class="title">添加</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body" v-loading="loadingForm" style="height: 400px">

        <el-form :model="addForm" :rules="rules" ref="addForm">

          <el-row>
            <el-col :span="12" class="item">
              <el-form-item label="商品标题" required prop="name">
                <el-input v-model="addForm.name" placeholder="输入商品标题"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="商品副标题">
                <el-input v-model="addForm.nameMore" placeholder="输入商品副标题"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="8" class="item">
              <el-form-item label="系统分类" required prop="goodsClassCode">
                <el-cascader v-model="addForm.goodsClassCode"
                             :options="goodsClassGovValue" placeholder="选择系统分类"
                             :props="options" style="width:100%"
                             @change="goodsClassGovChange"></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="8" class="item">
              <el-form-item label="商家分类" required prop="goodsClassBusinessCode">
                <el-select v-model="addForm.goodsClassBusinessCode"
                           style="width:100%" placeholder="选择商家分类">
                  <el-option
                      v-for="item in goodsClassBusinessValue"
                      :key="item.goodsClassBusinessCode"
                      :label="item.name"
                      :value="item.goodsClassBusinessCode">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8" class="item">
              <el-form-item label="商品类型" required prop="goodsType">
                <el-select v-model="addForm.goodsType" style="width:100%" placeholder="选择商品类型">
                  <el-option
                      v-for="item in goodsTypeValue"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>


          <el-row v-if='atrList.length==0'>
            <el-col :span="8" class="item">
              <el-form-item label="价格" required prop="priceMin">
                <el-input v-model.trim="addForm.priceMin" min="0"
                          onkeyup="this.value= this.value.match(/\d+(\.\d{0,2})?/) ? this.value.match(/\d+(\.\d{0,2})?/)[0] : ''"
                          placeholder="请输入商品价格">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" class="item">
              <el-form-item label="库存" required prop="stock">
                <div style="margin-top:40px">
                  <el-input-number :precision='0' :min="0"
                                   v-model.trim="addForm.stock" ></el-input-number>
                </div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row v-if='atrList.length>0'>
            <el-col :span="24" class="item" v-for="(item,i) in atrList" :key='i' >
              <el-form-item :label="item.name" required>
                <el-checkbox-group v-model="addForm.selectAtrValue[item.key]" @change="selectChangeAtr" style="margin-top: 40px;">
                  <el-checkbox v-for="items in item.attrValue" :label="items.attrValueCode" :key="items.attrValueCode">{{items.name}}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
            <template>
              <el-table :data="tablePriceArray" :span-method="arraySpanMethod" border
                        v-if="tablePriceArray.length>0" style="width: 100%">
                <el-table-column
                    v-for="(item,i) in atrList"
                    :key='i'
                    :prop="item.key.replace('Code','Name')"
                    :label="item.name">
                </el-table-column>
                <el-table-column label="价格">
                  <template slot-scope="item">
                    <el-input size="small" v-model.trim="item.row.price" min="0"
                              onkeyup="this.value= this.value.match(/\d+(\.\d{0,2})?/) ? this.value.match(/\d+(\.\d{0,2})?/)[0] : ''"
                              type="number">
                      <template slot="append">
                        <span>元</span>
                      </template>
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column label="最小价格">
                  <template slot-scope="item">
                    <el-input size="small" v-model.trim="item.row.priceMin" min="0"
                              onkeyup="this.value= this.value.match(/\d+(\.\d{0,2})?/) ? this.value.match(/\d+(\.\d{0,2})?/)[0] : ''"
                              type="number">
                      <template slot="append">
                        <span>元</span>
                      </template>
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column label="库存">
                  <template slot-scope="item">
                    <el-input-number size="small" :precision='0' :min="0" v-model.trim="item.row.stock"></el-input-number>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-row>


          <el-row>
            <el-col :span="24" class="item">
              <el-form-item label="其它" style="">
                <div style="color: #fff;">d</div>
                <el-checkbox v-model="addForm.isRecommend" :true-label='1' :false-label="0">推荐</el-checkbox>
                <el-checkbox v-model="addForm.isBargainPrice" :true-label='1' :false-label="0">特价</el-checkbox>

                <el-checkbox disabled v-model="addForm.isAPP" :true-label='1' :false-label="0">长者端商品</el-checkbox>
                <el-checkbox disabled v-model="addForm.isJiFen" :true-label='1' :false-label="0">积分商品</el-checkbox>
                <el-checkbox disabled v-model="addForm.isPad" :true-label='1' :false-label="0">收银机商品</el-checkbox>

              </el-form-item>
            </el-col>
          </el-row>


          <el-row>
            <el-col :span="24" class="item">
              <el-form-item label="商品图片">
                <div style="color: #fff;">d</div>
                <el-upload
                    action=""
                    :limit="limitCount"
                    :on-preview="handlePictureCardPreview"
                    :on-change="handleChange"
                    :http-request="uploadHttp"
                    list-type="picture-card"
                    :on-remove="handleRemove"
                    :class="{disabled:uploadDisabled}"
                    :file-list="fileList">
                  <i slot="default" class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :modal-append-to-body="false" :visible.sync="imgVisible" width="30%">
                  <img width="100%" :src="dialogImageUrl" alt="图片未找到"/>
                </el-dialog>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24" class="item">
              <el-form-item label="商品详情" required prop="details">
                <Quill placeholder='请输入详情' v-model='addForm.details' editorRef='addQuill' @input="handelIncrease"></Quill>
              </el-form-item>
            </el-col>
          </el-row>


        </el-form>

      </div>

      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('addForm')">提交</el-button>
      </div>

    </div>
  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode, getStaffDTO} from "@/utils/auth";

import Quill from "@/components/Quill";


export default {
  name: 'Add',
  props:['goodsClassGovValue','goodsClassBusinessValue'],
  data() {
    return {

      loadingForm:false,
      loading: false,

      disPrice: true,
      disImg: true,
      disDetails: true,

      columns:'',
      activeStep:0,
      tablePriceArray:[],
      atrList:[],

      tab:'0',
      imageUrl:"",

      addForm:{
        timeStr:timeStr,
        sign:'',
        staffCode:getStaffCode(),

        name:'',
        nameMore:'',

        goodsClassCode:'',
        goodsClassBusinessCode:'',
        goodsType:"",

        priceMin:'',
        priceStr:'',
        stock:'100',

        priceList:[],
        selectAtrValue:{},

        isRecommend:'0',
        isBargainPrice:'0',
        isAPP:'0',
        isPad:'0',
        isJiFen:'0',

        head1:'',
        head2:'',
        head3:'',
        head4:'',
        head5:'',

        details:'',

      },

      options:{
        value:'goodsClassCode',
        label:'name',
        children:'goodsClassGovernmentList',
        emitPath:false
      },


      rules:{
        name:[
          { required: true, message: '请输入商品标题', trigger: 'blur' }
        ],

        goodsClassCode:[
          { required: true, message: '请选择系统分类', trigger: 'blur' }
        ],
        goodsClassBusinessCode:[
          { required: true, message: '请选择商家分类', trigger: 'blur' }
        ],
        goodsType:[
          { required: true, message: '请选择商品类型', trigger: 'blur' }
        ],

        priceMin:[
          { required: true, message: '请输入商品价格', trigger: 'blur' }
        ],
        stock:[
          { required: true, message: '请输入商品库存', trigger: 'blur' }
        ],
        details:[
          { required: true, message: '请输入商品详情', trigger: 'blur' }
        ],

      },


      goodsTypeValue: [ {
        value: 2,
        label: '单独服务类'
      }, {
        value: 3,
        label: '合并服务类'
      }],



      //上传身份证正面相关参数
      limitCount: 5,
      uploadDisabled: false,
      // 是否显示预览图片
      imgVisible: false,
      // 预览图片url
      dialogImageUrl: "",
      fileList: [],

    }
  },
  components:{Quill},
  methods: {
    init(){

      this.$refs.addForm.resetFields();

      this.loadingForm = false;

      this.addForm.nameMore = '';

      this.tablePriceArray=[]
      this.atrList=[]
      this.addForm.selectAtrValue={}
      this.addForm.priceList=[]

      for(var key=0;key<=4;key++){
        this.addForm['head'+(key+1)]=''
      }


      this.fileList = [];

      let dto = getStaffDTO();
      let businessType = dto.businessDTO.businessType;
      if(businessType == 1){

        this.addForm.isAPP = 1;
        this.goodsTypeValue= [{
          value: 2,
          label: '单独服务类'
        }, {
          value: 3,
          label: '合并服务类'
        }];
      }
      if(businessType == 2){

        this.addForm.isJiFen = 1;
        this.goodsTypeValue= [ {
          value: 2,
          label: '单独服务类'
        }, {
          value: 3,
          label: '合并服务类'
        }];
      }
      if(businessType == 3){

        this.addForm.isAPP = 1;
        this.addForm.isPad = 1;
        this.goodsTypeValue= [{
          value: 3,
          label: '合并服务类'
        }];
      }

    },


    goodsClassGovChange(val){
      this.tablePriceArray=[]
      this.atrList=[]
      this.addForm.selectAtrValue={}
      this.getPriceArray(val)
    },

    //获取商品分类的属性
    getPriceArray(addGoodsClassCode){

      this.loadingForm = true;

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"GoodsAttribute/ListByGoodsClassCode",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          goodsClassCode:addGoodsClassCode
        }
      }).then((response) => {

            if(response.data.error === 0) {
              this.loadingForm=false
              var data=response.data.data

              if(data.length==0){
                this.addForm.priceMin='';
                this.addForm.stock='100';
                return;
              }

              var list=[]
              for(var i in data){
                var attrValue=''
                let datai=data[i]
                //goods***Code
                let attributeName=datai.code.replace('G','g')
                //goods***List
                let attributeListName=attributeName.replace('Code','List')
                attrValue=JSON.stringify(datai[attributeListName])
                attrValue=attrValue.replace(new RegExp(attributeName,'g'),'attrValueCode')
                attrValue=attrValue.replace(/"status":1/g,'"status":"'+attributeName+'"')
                attrValue=JSON.parse(attrValue)
                this.$set(this.addForm.selectAtrValue,attributeName,[])
                let listvalue={
                  key:attributeName,
                  name:datai.name,
                  attrValue:attrValue,
                }
                list.push(listvalue)
              }

              this.atrList=list

            }
            else if(response.data.error === 1){
              this.$emit("closeAdd");
              this.$message.error(response.data.message)
            }

          }).catch(function () {
            this.$emit("closeAdd");
            this.$message.error('加载失败')
          });

    },





    keyupEvent(){
      console.log(this.tablePriceArray)
    },

    //获取列表
    fromName(list,index,array,template) {
      var lists=list[index].attrValue
      for(var i in lists){
        let templates={}
        var name=lists[i].status.replace('Code','Name')
        templates[lists[i].status]=lists[i].attrValueCode
        templates[name]=lists[i].name
        var template1=Object.assign(templates,template);
        if(index!=0){
          var arrayList=this.fromName(list,index-1,array,template1)
          array.concat(arrayList)
        }else{
          template1.price=0
          template1.priceMin=0
          template1.stock=0
          array.push(template1)
        }
      }
      return array
    },

    //根据选择获取属性
    selectChangeAtr(){
      var data=this.addForm.selectAtrValue
      var is=true
      for(var i in data){
        if(data[i].length==0){
          is=false
        }
      }
      if(is){
        const atrList=JSON.parse(JSON.stringify(this.atrList));
        var list=this.getAtrList(data,atrList)
        var table=this.fromName(list,list.length-1,[],{})
        this.tablePriceArray=this.getTablePriceArray(table)
        //表格排序
        var key=Object.keys(this.addForm.selectAtrValue)[0].replace('Code','Name')
        this.tablePriceArray.sort(this.compare(key))
      }else{
        this.tablePriceArray=[]
      }
    },

    compare(property) {
      return function (a, b) {
        var value1 = a[property];
        var value2 = b[property];
        return value1.localeCompare(value2);
      }
    },
    getTablePriceArray(table){
      for(var i in table){
        for(var j in this.tablePriceArray){
          if(this.objvequal(table[i],this.tablePriceArray[j])){
            table[i].price=this.tablePriceArray[j].price
            table[i].stock=this.tablePriceArray[j].stock
            table[i].priceMin=this.tablePriceArray[j].priceMin
          }
        }
      }
      return table
    },
    //判读对象是否相等
    objvequal(obj1,obj2){
      for(var i in obj1){
        if(i!='price'&&i!='stock'&&i!='priceMin'){
          if (obj1[i] != obj2[i]) {
            return false;
          }
        }
      }
      return true;
    },
    getAtrList(data,list){
      for(var i in list){
        for (let j = list[i].attrValue.length - 1; j >= 0; j--) {
          var code=list[i].attrValue[j].attrValueCode
          if(data[list[i].key].indexOf(code)==-1){
            list[i].attrValue.splice(j,1);
          }
        }
      }
      return list
    },
    handelIncrease(step) {
      this.addForm.details=step
    },




    closeSelf() {
      this.$emit("closeAdd");
    },

    confirm(addForm){

      this.$refs[addForm].validate((valid) => {
        if(valid){

          if(this.fileList.length==0){
            this.$message.warning('请至少上传一张图片')
            return
          }

          if(this.atrList.length>0){
            if(this.tablePriceArray.length==0){
              this.$message.warning('请选择完整的商品属性')
              return;
            }
            for(var i in this.tablePriceArray){
              if(this.tablePriceArray[i].price==0){
                this.$message.warning('请完善商品价格')
                return;
              }
            }
          }

          this.addSubmit();

        }else {
          console.log('error submit!!');
          return false;
        }
      })


    },

    addSubmit(){

      for(let i=0;i<this.fileList.length;i++){
        let path = this.fileList[i].url;
        path = path.replace(this.$imgUrl,'');

        this.addForm['head'+(i+1)] = path;
      }

      this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);


      if(this.atrList.length==0){
        this.addForm.priceList=[{goodsColorCode:'',goodsSizeCode:'',stock:this.addForm.stock,price:this.addForm.priceMin}]
        this.addForm.priceStr=this.addForm.priceMin;
      }
      else{
        this.tablePriceArray.sort(function(a,b){
          return a.price-b.price
        })
        this.addForm.priceStr=this.tablePriceArray[0].price+'~'+this.tablePriceArray[this.tablePriceArray.length-1].price
      }


      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Goods/AddForAll",
        data: this.addForm
      }).then((response) => {
            this.loading = false;
            if (response.data.error == 0) {
              this.$emit("closeAdd");
              this.$emit("getList");
            }else if(response.data.error == 1){
              this.$message.error(response.data.message)
            }
          })
    },

    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      this.columns=column
      var key=Object.keys(this.addForm.selectAtrValue)[0]
      if (columnIndex === 0) {
        if(rowIndex ===0 || row[key] != this.tablePriceArray[rowIndex-1][key]){
          let rowspan = 0;
          this.tablePriceArray.forEach(element => {
            if(element[key] === row[key]){
              rowspan ++;
            }
          });
          return [rowspan, 1];
        }else {
          return [0, 0];
        }
      }
    },







    // 预览图片
    handlePictureCardPreview(file) {
      this.imgVisible = true;
      this.dialogImageUrl = file.url;
    },
    // 删除图片
    handleRemove(file, fileList) {
      this.uploadDisabled = fileList.length >= this.limitCount;

      let Pics = this.fileList;
      Pics.forEach((item, index) => {
        if (file.url == item.url) {
          Pics.splice(index, 1);
        }
      })
      Pics.forEach((item, index) => {
        if (file.uid == item.uid) {
          Pics.splice(index, 1);
        }
      })

    },

    //图片更改
    handleChange(file,fileList) {
      this.fileList.push({uid:file.uid,name:file.name,url:''});
      this.uploadDisabled = fileList.length >= this.limitCount;
    },

    uploadHttp(file) {

      let fd = new FormData();
      fd.append('file',file.file);
      fd.append('staffCode',getStaffCode());
      fd.append('timeStr',timeStr);
      fd.append('sign',hex_md5("timeStr=" + timeStr + "&key="+this.$signKey));

      let that = this;
      this.$axios.post(this.$shopUrl+'Upload/Imgs',fd).then(function(res){
        //console.log(res.data);

        if(res.data.error == 0){
          for(let i=0;i<that.fileList.length;i++){
            if(that.fileList[i].uid == file.file.uid){
              that.fileList[i].url = that.$imgUrl+ res.data.data.path;
            }
          }
        }
        else if(res.data.error == 1){
          let Pics = that.fileList;
          Pics.forEach((item, index) => {
            if (file.file.uid == item.uid) {
              Pics.splice(index, 1);
            }
          })
        }

        that.uploadDisabled = that.fileList.length >= that.limitCount;


      }).catch(error => {
        console.log(error);

        let Pics = that.fileList;
        Pics.forEach((item, index) => {
          if (file.file.uid == item.uid) {
            Pics.splice(index, 1);
          }
        })

        that.uploadDisabled = that.fileList.length >= that.limitCount;

      })


    },






  }
}


</script>


<style>
.disabled .el-upload--picture-card {
  display: none;
}
</style>

<style lang="scss" scoped>

</style>
